/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createUnreadNotification = /* GraphQL */ `
  mutation CreateUnreadNotification($input: UnreadNotificationInput!) {
    createUnreadNotification(input: $input) {
      submissionId
      conversationId
      unreadCount
      lastMessagePreview
      timestamp
      mobileNumber
      __typename
    }
  }
`;
export const markMessagesAsRead = /* GraphQL */ `
  mutation MarkMessagesAsRead($conversationId: ID!) {
    markMessagesAsRead(conversationId: $conversationId) {
      conversationId
      markedCount
      success
      __typename
    }
  }
`;
export const createSubmission = /* GraphQL */ `
  mutation CreateSubmission(
    $input: CreateSubmissionInput!
    $condition: ModelSubmissionConditionInput
  ) {
    createSubmission(input: $input, condition: $condition) {
      id
      publicId
      SID
      createdAt
      mobilenumber
      age
      gender
      householdincome
      sendwelcomesms
      state
      transgender
      updatedAt
      zipcode
      Status
      updatedBy
      Notes
      userscore
      eligible
      needsAlternateTime
      alternateTimeRequestedAt
      conversations {
        nextToken
        __typename
      }
      appointments {
        nextToken
        __typename
      }
      statusHistory {
        nextToken
        __typename
      }
      messageVariants {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateSubmission = /* GraphQL */ `
  mutation UpdateSubmission(
    $input: UpdateSubmissionInput!
    $condition: ModelSubmissionConditionInput
  ) {
    updateSubmission(input: $input, condition: $condition) {
      id
      publicId
      SID
      createdAt
      mobilenumber
      age
      gender
      householdincome
      sendwelcomesms
      state
      transgender
      updatedAt
      zipcode
      Status
      updatedBy
      Notes
      userscore
      eligible
      needsAlternateTime
      alternateTimeRequestedAt
      conversations {
        nextToken
        __typename
      }
      appointments {
        nextToken
        __typename
      }
      statusHistory {
        nextToken
        __typename
      }
      messageVariants {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteSubmission = /* GraphQL */ `
  mutation DeleteSubmission(
    $input: DeleteSubmissionInput!
    $condition: ModelSubmissionConditionInput
  ) {
    deleteSubmission(input: $input, condition: $condition) {
      id
      publicId
      SID
      createdAt
      mobilenumber
      age
      gender
      householdincome
      sendwelcomesms
      state
      transgender
      updatedAt
      zipcode
      Status
      updatedBy
      Notes
      userscore
      eligible
      needsAlternateTime
      alternateTimeRequestedAt
      conversations {
        nextToken
        __typename
      }
      appointments {
        nextToken
        __typename
      }
      statusHistory {
        nextToken
        __typename
      }
      messageVariants {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createSubmissionStatusHistory = /* GraphQL */ `
  mutation CreateSubmissionStatusHistory(
    $input: CreateSubmissionStatusHistoryInput!
    $condition: ModelSubmissionStatusHistoryConditionInput
  ) {
    createSubmissionStatusHistory(input: $input, condition: $condition) {
      id
      submissionId
      submission {
        id
        publicId
        SID
        createdAt
        mobilenumber
        age
        gender
        householdincome
        sendwelcomesms
        state
        transgender
        updatedAt
        zipcode
        Status
        updatedBy
        Notes
        userscore
        eligible
        needsAlternateTime
        alternateTimeRequestedAt
        __typename
      }
      previousStatus
      newStatus
      changedAt
      changedBy
      reason
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSubmissionStatusHistory = /* GraphQL */ `
  mutation UpdateSubmissionStatusHistory(
    $input: UpdateSubmissionStatusHistoryInput!
    $condition: ModelSubmissionStatusHistoryConditionInput
  ) {
    updateSubmissionStatusHistory(input: $input, condition: $condition) {
      id
      submissionId
      submission {
        id
        publicId
        SID
        createdAt
        mobilenumber
        age
        gender
        householdincome
        sendwelcomesms
        state
        transgender
        updatedAt
        zipcode
        Status
        updatedBy
        Notes
        userscore
        eligible
        needsAlternateTime
        alternateTimeRequestedAt
        __typename
      }
      previousStatus
      newStatus
      changedAt
      changedBy
      reason
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSubmissionStatusHistory = /* GraphQL */ `
  mutation DeleteSubmissionStatusHistory(
    $input: DeleteSubmissionStatusHistoryInput!
    $condition: ModelSubmissionStatusHistoryConditionInput
  ) {
    deleteSubmissionStatusHistory(input: $input, condition: $condition) {
      id
      submissionId
      submission {
        id
        publicId
        SID
        createdAt
        mobilenumber
        age
        gender
        householdincome
        sendwelcomesms
        state
        transgender
        updatedAt
        zipcode
        Status
        updatedBy
        Notes
        userscore
        eligible
        needsAlternateTime
        alternateTimeRequestedAt
        __typename
      }
      previousStatus
      newStatus
      changedAt
      changedBy
      reason
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createConversation = /* GraphQL */ `
  mutation CreateConversation(
    $input: CreateConversationInput!
    $condition: ModelConversationConditionInput
  ) {
    createConversation(input: $input, condition: $condition) {
      id
      submissionId
      submission {
        id
        publicId
        SID
        createdAt
        mobilenumber
        age
        gender
        householdincome
        sendwelcomesms
        state
        transgender
        updatedAt
        zipcode
        Status
        updatedBy
        Notes
        userscore
        eligible
        needsAlternateTime
        alternateTimeRequestedAt
        __typename
      }
      createdAt
      lastMessageTime
      updatedAt
      status
      unreadCount
      lastMessageContent
      lastMessageDirection
      twilioConversationSid
      messages {
        nextToken
        __typename
      }
      participants {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateConversation = /* GraphQL */ `
  mutation UpdateConversation(
    $input: UpdateConversationInput!
    $condition: ModelConversationConditionInput
  ) {
    updateConversation(input: $input, condition: $condition) {
      id
      submissionId
      submission {
        id
        publicId
        SID
        createdAt
        mobilenumber
        age
        gender
        householdincome
        sendwelcomesms
        state
        transgender
        updatedAt
        zipcode
        Status
        updatedBy
        Notes
        userscore
        eligible
        needsAlternateTime
        alternateTimeRequestedAt
        __typename
      }
      createdAt
      lastMessageTime
      updatedAt
      status
      unreadCount
      lastMessageContent
      lastMessageDirection
      twilioConversationSid
      messages {
        nextToken
        __typename
      }
      participants {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteConversation = /* GraphQL */ `
  mutation DeleteConversation(
    $input: DeleteConversationInput!
    $condition: ModelConversationConditionInput
  ) {
    deleteConversation(input: $input, condition: $condition) {
      id
      submissionId
      submission {
        id
        publicId
        SID
        createdAt
        mobilenumber
        age
        gender
        householdincome
        sendwelcomesms
        state
        transgender
        updatedAt
        zipcode
        Status
        updatedBy
        Notes
        userscore
        eligible
        needsAlternateTime
        alternateTimeRequestedAt
        __typename
      }
      createdAt
      lastMessageTime
      updatedAt
      status
      unreadCount
      lastMessageContent
      lastMessageDirection
      twilioConversationSid
      messages {
        nextToken
        __typename
      }
      participants {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createMessage = /* GraphQL */ `
  mutation CreateMessage(
    $input: CreateMessageInput!
    $condition: ModelMessageConditionInput
  ) {
    createMessage(input: $input, condition: $condition) {
      id
      conversationId
      conversation {
        id
        submissionId
        createdAt
        lastMessageTime
        updatedAt
        status
        unreadCount
        lastMessageContent
        lastMessageDirection
        twilioConversationSid
        __typename
      }
      content
      name
      direction
      phoneNumber
      timestamp
      read
      readAt
      messageSid
      mediaUrls
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateMessage = /* GraphQL */ `
  mutation UpdateMessage(
    $input: UpdateMessageInput!
    $condition: ModelMessageConditionInput
  ) {
    updateMessage(input: $input, condition: $condition) {
      id
      conversationId
      conversation {
        id
        submissionId
        createdAt
        lastMessageTime
        updatedAt
        status
        unreadCount
        lastMessageContent
        lastMessageDirection
        twilioConversationSid
        __typename
      }
      content
      name
      direction
      phoneNumber
      timestamp
      read
      readAt
      messageSid
      mediaUrls
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteMessage = /* GraphQL */ `
  mutation DeleteMessage(
    $input: DeleteMessageInput!
    $condition: ModelMessageConditionInput
  ) {
    deleteMessage(input: $input, condition: $condition) {
      id
      conversationId
      conversation {
        id
        submissionId
        createdAt
        lastMessageTime
        updatedAt
        status
        unreadCount
        lastMessageContent
        lastMessageDirection
        twilioConversationSid
        __typename
      }
      content
      name
      direction
      phoneNumber
      timestamp
      read
      readAt
      messageSid
      mediaUrls
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createParticipant = /* GraphQL */ `
  mutation CreateParticipant(
    $input: CreateParticipantInput!
    $condition: ModelParticipantConditionInput
  ) {
    createParticipant(input: $input, condition: $condition) {
      id
      conversationId
      conversation {
        id
        submissionId
        createdAt
        lastMessageTime
        updatedAt
        status
        unreadCount
        lastMessageContent
        lastMessageDirection
        twilioConversationSid
        __typename
      }
      phoneNumber
      twilioSid
      name
      role
      isRequired
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateParticipant = /* GraphQL */ `
  mutation UpdateParticipant(
    $input: UpdateParticipantInput!
    $condition: ModelParticipantConditionInput
  ) {
    updateParticipant(input: $input, condition: $condition) {
      id
      conversationId
      conversation {
        id
        submissionId
        createdAt
        lastMessageTime
        updatedAt
        status
        unreadCount
        lastMessageContent
        lastMessageDirection
        twilioConversationSid
        __typename
      }
      phoneNumber
      twilioSid
      name
      role
      isRequired
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteParticipant = /* GraphQL */ `
  mutation DeleteParticipant(
    $input: DeleteParticipantInput!
    $condition: ModelParticipantConditionInput
  ) {
    deleteParticipant(input: $input, condition: $condition) {
      id
      conversationId
      conversation {
        id
        submissionId
        createdAt
        lastMessageTime
        updatedAt
        status
        unreadCount
        lastMessageContent
        lastMessageDirection
        twilioConversationSid
        __typename
      }
      phoneNumber
      twilioSid
      name
      role
      isRequired
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDuplicateSubmission = /* GraphQL */ `
  mutation CreateDuplicateSubmission(
    $input: CreateDuplicateSubmissionInput!
    $condition: ModelDuplicateSubmissionConditionInput
  ) {
    createDuplicateSubmission(input: $input, condition: $condition) {
      id
      SID
      createdAt
      mobilenumber
      age
      gender
      householdincome
      state
      transgender
      updatedAt
      zipcode
      originalSubmissionId
      __typename
    }
  }
`;
export const updateDuplicateSubmission = /* GraphQL */ `
  mutation UpdateDuplicateSubmission(
    $input: UpdateDuplicateSubmissionInput!
    $condition: ModelDuplicateSubmissionConditionInput
  ) {
    updateDuplicateSubmission(input: $input, condition: $condition) {
      id
      SID
      createdAt
      mobilenumber
      age
      gender
      householdincome
      state
      transgender
      updatedAt
      zipcode
      originalSubmissionId
      __typename
    }
  }
`;
export const deleteDuplicateSubmission = /* GraphQL */ `
  mutation DeleteDuplicateSubmission(
    $input: DeleteDuplicateSubmissionInput!
    $condition: ModelDuplicateSubmissionConditionInput
  ) {
    deleteDuplicateSubmission(input: $input, condition: $condition) {
      id
      SID
      createdAt
      mobilenumber
      age
      gender
      householdincome
      state
      transgender
      updatedAt
      zipcode
      originalSubmissionId
      __typename
    }
  }
`;
export const createAppointmentSlot = /* GraphQL */ `
  mutation CreateAppointmentSlot(
    $input: CreateAppointmentSlotInput!
    $condition: ModelAppointmentSlotConditionInput
  ) {
    createAppointmentSlot(input: $input, condition: $condition) {
      id
      date
      startTime
      endTime
      isBooked
      createdBy
      updatedBy
      createdAt
      updatedAt
      appointment {
        id
        slotId
        submissionId
        bookedAt
        status
        updatedBy
        notes
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const updateAppointmentSlot = /* GraphQL */ `
  mutation UpdateAppointmentSlot(
    $input: UpdateAppointmentSlotInput!
    $condition: ModelAppointmentSlotConditionInput
  ) {
    updateAppointmentSlot(input: $input, condition: $condition) {
      id
      date
      startTime
      endTime
      isBooked
      createdBy
      updatedBy
      createdAt
      updatedAt
      appointment {
        id
        slotId
        submissionId
        bookedAt
        status
        updatedBy
        notes
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const deleteAppointmentSlot = /* GraphQL */ `
  mutation DeleteAppointmentSlot(
    $input: DeleteAppointmentSlotInput!
    $condition: ModelAppointmentSlotConditionInput
  ) {
    deleteAppointmentSlot(input: $input, condition: $condition) {
      id
      date
      startTime
      endTime
      isBooked
      createdBy
      updatedBy
      createdAt
      updatedAt
      appointment {
        id
        slotId
        submissionId
        bookedAt
        status
        updatedBy
        notes
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const createAppointment = /* GraphQL */ `
  mutation CreateAppointment(
    $input: CreateAppointmentInput!
    $condition: ModelAppointmentConditionInput
  ) {
    createAppointment(input: $input, condition: $condition) {
      id
      slotId
      slot {
        id
        date
        startTime
        endTime
        isBooked
        createdBy
        updatedBy
        createdAt
        updatedAt
        __typename
      }
      submissionId
      submission {
        id
        publicId
        SID
        createdAt
        mobilenumber
        age
        gender
        householdincome
        sendwelcomesms
        state
        transgender
        updatedAt
        zipcode
        Status
        updatedBy
        Notes
        userscore
        eligible
        needsAlternateTime
        alternateTimeRequestedAt
        __typename
      }
      bookedAt
      status
      updatedBy
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateAppointment = /* GraphQL */ `
  mutation UpdateAppointment(
    $input: UpdateAppointmentInput!
    $condition: ModelAppointmentConditionInput
  ) {
    updateAppointment(input: $input, condition: $condition) {
      id
      slotId
      slot {
        id
        date
        startTime
        endTime
        isBooked
        createdBy
        updatedBy
        createdAt
        updatedAt
        __typename
      }
      submissionId
      submission {
        id
        publicId
        SID
        createdAt
        mobilenumber
        age
        gender
        householdincome
        sendwelcomesms
        state
        transgender
        updatedAt
        zipcode
        Status
        updatedBy
        Notes
        userscore
        eligible
        needsAlternateTime
        alternateTimeRequestedAt
        __typename
      }
      bookedAt
      status
      updatedBy
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteAppointment = /* GraphQL */ `
  mutation DeleteAppointment(
    $input: DeleteAppointmentInput!
    $condition: ModelAppointmentConditionInput
  ) {
    deleteAppointment(input: $input, condition: $condition) {
      id
      slotId
      slot {
        id
        date
        startTime
        endTime
        isBooked
        createdBy
        updatedBy
        createdAt
        updatedAt
        __typename
      }
      submissionId
      submission {
        id
        publicId
        SID
        createdAt
        mobilenumber
        age
        gender
        householdincome
        sendwelcomesms
        state
        transgender
        updatedAt
        zipcode
        Status
        updatedBy
        Notes
        userscore
        eligible
        needsAlternateTime
        alternateTimeRequestedAt
        __typename
      }
      bookedAt
      status
      updatedBy
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createMessageTemplate = /* GraphQL */ `
  mutation CreateMessageTemplate(
    $input: CreateMessageTemplateInput!
    $condition: ModelMessageTemplateConditionInput
  ) {
    createMessageTemplate(input: $input, condition: $condition) {
      id
      type
      content
      isActive
      createdAt
      updatedAt
      createdBy
      updatedBy
      __typename
    }
  }
`;
export const updateMessageTemplate = /* GraphQL */ `
  mutation UpdateMessageTemplate(
    $input: UpdateMessageTemplateInput!
    $condition: ModelMessageTemplateConditionInput
  ) {
    updateMessageTemplate(input: $input, condition: $condition) {
      id
      type
      content
      isActive
      createdAt
      updatedAt
      createdBy
      updatedBy
      __typename
    }
  }
`;
export const deleteMessageTemplate = /* GraphQL */ `
  mutation DeleteMessageTemplate(
    $input: DeleteMessageTemplateInput!
    $condition: ModelMessageTemplateConditionInput
  ) {
    deleteMessageTemplate(input: $input, condition: $condition) {
      id
      type
      content
      isActive
      createdAt
      updatedAt
      createdBy
      updatedBy
      __typename
    }
  }
`;
export const createOffHoursConfig = /* GraphQL */ `
  mutation CreateOffHoursConfig(
    $input: CreateOffHoursConfigInput!
    $condition: ModelOffHoursConfigConditionInput
  ) {
    createOffHoursConfig(input: $input, condition: $condition) {
      id
      isEnabled
      weekdayStartTime
      weekdayEndTime
      weekendStartTime
      weekendEndTime
      updatedAt
      updatedBy
      createdAt
      __typename
    }
  }
`;
export const updateOffHoursConfig = /* GraphQL */ `
  mutation UpdateOffHoursConfig(
    $input: UpdateOffHoursConfigInput!
    $condition: ModelOffHoursConfigConditionInput
  ) {
    updateOffHoursConfig(input: $input, condition: $condition) {
      id
      isEnabled
      weekdayStartTime
      weekdayEndTime
      weekendStartTime
      weekendEndTime
      updatedAt
      updatedBy
      createdAt
      __typename
    }
  }
`;
export const deleteOffHoursConfig = /* GraphQL */ `
  mutation DeleteOffHoursConfig(
    $input: DeleteOffHoursConfigInput!
    $condition: ModelOffHoursConfigConditionInput
  ) {
    deleteOffHoursConfig(input: $input, condition: $condition) {
      id
      isEnabled
      weekdayStartTime
      weekdayEndTime
      weekendStartTime
      weekendEndTime
      updatedAt
      updatedBy
      createdAt
      __typename
    }
  }
`;
export const createAppointmentMessageVariantTemplate = /* GraphQL */ `
  mutation CreateAppointmentMessageVariantTemplate(
    $input: CreateAppointmentMessageVariantTemplateInput!
    $condition: ModelAppointmentMessageVariantTemplateConditionInput
  ) {
    createAppointmentMessageVariantTemplate(
      input: $input
      condition: $condition
    ) {
      id
      variantTrack
      messageType
      content
      isActive
      mrt
      response1
      response2
      createdAt
      updatedAt
      createdBy
      updatedBy
      __typename
    }
  }
`;
export const updateAppointmentMessageVariantTemplate = /* GraphQL */ `
  mutation UpdateAppointmentMessageVariantTemplate(
    $input: UpdateAppointmentMessageVariantTemplateInput!
    $condition: ModelAppointmentMessageVariantTemplateConditionInput
  ) {
    updateAppointmentMessageVariantTemplate(
      input: $input
      condition: $condition
    ) {
      id
      variantTrack
      messageType
      content
      isActive
      mrt
      response1
      response2
      createdAt
      updatedAt
      createdBy
      updatedBy
      __typename
    }
  }
`;
export const deleteAppointmentMessageVariantTemplate = /* GraphQL */ `
  mutation DeleteAppointmentMessageVariantTemplate(
    $input: DeleteAppointmentMessageVariantTemplateInput!
    $condition: ModelAppointmentMessageVariantTemplateConditionInput
  ) {
    deleteAppointmentMessageVariantTemplate(
      input: $input
      condition: $condition
    ) {
      id
      variantTrack
      messageType
      content
      isActive
      mrt
      response1
      response2
      createdAt
      updatedAt
      createdBy
      updatedBy
      __typename
    }
  }
`;
export const createUserMessageVariant = /* GraphQL */ `
  mutation CreateUserMessageVariant(
    $input: CreateUserMessageVariantInput!
    $condition: ModelUserMessageVariantConditionInput
  ) {
    createUserMessageVariant(input: $input, condition: $condition) {
      id
      submissionId
      submission {
        id
        publicId
        SID
        createdAt
        mobilenumber
        age
        gender
        householdincome
        sendwelcomesms
        state
        transgender
        updatedAt
        zipcode
        Status
        updatedBy
        Notes
        userscore
        eligible
        needsAlternateTime
        alternateTimeRequestedAt
        __typename
      }
      status
      variantTrack
      assignedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUserMessageVariant = /* GraphQL */ `
  mutation UpdateUserMessageVariant(
    $input: UpdateUserMessageVariantInput!
    $condition: ModelUserMessageVariantConditionInput
  ) {
    updateUserMessageVariant(input: $input, condition: $condition) {
      id
      submissionId
      submission {
        id
        publicId
        SID
        createdAt
        mobilenumber
        age
        gender
        householdincome
        sendwelcomesms
        state
        transgender
        updatedAt
        zipcode
        Status
        updatedBy
        Notes
        userscore
        eligible
        needsAlternateTime
        alternateTimeRequestedAt
        __typename
      }
      status
      variantTrack
      assignedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUserMessageVariant = /* GraphQL */ `
  mutation DeleteUserMessageVariant(
    $input: DeleteUserMessageVariantInput!
    $condition: ModelUserMessageVariantConditionInput
  ) {
    deleteUserMessageVariant(input: $input, condition: $condition) {
      id
      submissionId
      submission {
        id
        publicId
        SID
        createdAt
        mobilenumber
        age
        gender
        householdincome
        sendwelcomesms
        state
        transgender
        updatedAt
        zipcode
        Status
        updatedBy
        Notes
        userscore
        eligible
        needsAlternateTime
        alternateTimeRequestedAt
        __typename
      }
      status
      variantTrack
      assignedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
